module.exports = __webpack_public_path__ + "img/5.be5dd254.jpg";